import type { MouseEvent } from 'react';

import BpkButton, {
  BUTTON_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-button';
import { withRtlSupport } from '@skyscanner-internal/backpack-web/bpk-component-icon';
import LongArrowIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/long-arrow-right';
import {
  BpkFlex,
  BpkVessel,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkPrice, {
  ALIGNS,
} from '@skyscanner-internal/backpack-web/bpk-component-price';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import { redirect } from 'saddlebag-browser';

import type { ProviderInfo } from '@skyscanner-internal/landing-pages-shared-types/types-shared/ProviderRating';

import STYLES from './Footer.module.scss';

const LongArrowRight = withRtlSupport(LongArrowIcon);

const onClick = (e: MouseEvent<Element>, props: ProviderInfo) => {
  e.stopPropagation();

  redirect(props.link, props.isOpenInNewTab);
};

const Footer = ({
  provider,
  strings,
}: {
  provider: ProviderInfo;
  strings: { [key: string]: string };
}) => {
  const { ariaLabelPrice, price, providerName } = provider;
  return (
    <BpkFlex
      justify={price ? 'space-between' : 'flex-end'}
      align="center"
      minHeight={price ? undefined : '2.8125rem'}
    >
      {price && (
        <BpkVessel
          className={STYLES.Footer__price}
          aria-label={ariaLabelPrice}
          role="status"
        >
          <BpkPrice
            align={ALIGNS.left}
            leadingText={strings.from}
            price={price}
            trailingText={strings.perDay}
          />
        </BpkVessel>
      )}
      <BpkButton
        className={STYLES.Footer__view}
        onClick={(e: MouseEvent<Element>) => onClick(e, provider)}
        type={BUTTON_TYPES.link}
        implicit
      >
        <BpkText textStyle={TEXT_STYLES.label1}>
          {strings.view.replace(/@@car_hire_provider@@/g, providerName)}
        </BpkText>
        <LongArrowRight />
      </BpkButton>
    </BpkFlex>
  );
};

export default Footer;
